/* esm.sh - detect-gpu@5.0.70 */
export * from "/*detect-gpu@5.0.70/esnext/detect-gpu.mjs";
